import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

//------------------------------------------------------------------------------
//               Отправить запрос на получение информации о посте
//------------------------------------------------------------------------------
export const deletePost = async ({ object_id }) => {
  try{
    const data = { object_id };
    const url = `${backendUrl}/api/alpha/moderation/delete`;
    const options = {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    };
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при удалении поста: HTTP error! Status: ${ response.status }`);
    }
    return response;
  } catch(error){
    console.error('Программная ошибка удаления поста:', error);
    throw error;
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx